module.exports = __webpack_public_path__ + "static/img/bg_coupon_four.eb85b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_four.png
// module id = ty2C
// module chunks = 0